import React, { useState, useEffect } from 'react';
import axios from 'axios';
import axiosInstance, { fronturl, weburl } from '../../../axiosInstance'; import { Link, useNavigate, useParams } from 'react-router-dom';
import Sidebar from '../../components/Sidebar';
import Navbar from '../../components/Navbar';
import toast from 'react-hot-toast';
import Gallery from '../../components/Gallery';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // Import Quill styles
import Select from 'react-select';
import { triggerChooseimg } from '../../components/ChooseImg';
import jsPDF from 'jspdf';

import html2canvas from 'html2canvas';
import getDecryptData from '../../../helpers/getDecryptData';
import { useThemeContext } from '../../../fetchdata/ThemeContext';

const FullOrderView = () => {

  const { sendMessage } = useThemeContext();

  const mydata = getDecryptData();
  const mydatatype = mydata.type || null;
  const mydatatypeEmp = mydata.empType || null;

  const [Order, setOrder] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [OrderPlace, setOrderPlace] = useState('');
  const [MYuser, setMYuser] = useState('');

  const { userId, id } = useParams();

  const [data, setData] = useState([]);
  const [filteredCities, setFilteredCities] = useState([]);
  const [loading, setLoading] = useState(true); // Add loading state

  const navigate = useNavigate();

  const saveAsPDF = async () => {
    const printContent = document.getElementById('print');

    // Set the scale factor for better quality
    const scale = 5;

    // Set the quality of the JPEG image
    const imageQuality = 1; // 1 is maximum quality

    // Convert print content to image with higher scale
    html2canvas(printContent, {
      scale: scale,
      useCORS: true, // Enable CORS to support loading images from different origins
      logging: true // Enable logging for debugging
    }).then(canvas => {
      const imgData = canvas.toDataURL('image/jpeg', imageQuality); // Use JPEG format with specified quality

      // Calculate dimensions of PDF page
      const pdfWidth = 297; // A4 width in mm
      const pdfHeight = 210; // A4 height in mm
      const ratio = canvas.width / canvas.height;

      let pdfHeightAdjusted = pdfHeight;
      let pdfWidthAdjusted = pdfWidth;

      if (ratio < pdfWidth / pdfHeight) {
        pdfWidthAdjusted = pdfHeight * ratio;
      } else {
        pdfHeightAdjusted = pdfWidth / ratio;
      }

      // Create a new jsPDF instance
      const pdf = new jsPDF({
        orientation: 'landscape', // Set the orientation of the PDF to landscape
        unit: 'mm', // Use millimeters as the unit for measurements
        format: [pdfWidth, pdfHeight] // Set the format of the PDF (A4 size)
      });

      // Add image to PDF document
      pdf.addImage(imgData, 'JPEG', 0, 0, pdfWidthAdjusted, pdfHeightAdjusted);

      // Save the PDF
      pdf.save("invoice.pdf");
    });
  }

  const fetchData = async () => {
    setLoading(true);
    console.log("response.data start");

    try {
      const response = await axiosInstance.get("/get-all-zones");
      console.log("response.data.Zones,", response.data.Zones);
      setData(response.data.Zones);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const [items, setItems] = useState([]);

  const handleItemChange = (index, field, value) => {
    const updatedItems = [...Order.items];
    updatedItems[index][field] = field === 'title' ? value : Number(value);

    // Update subtotal and totalAmount too
    const totalAmount = updatedItems.reduce(
      (acc, item) =>
        // acc + item.quantity * (item.price + (item.price * item.gst) / 100),
        acc + item.quantity * (item.price + (item.price) / 100), 0
    );

    setOrder(prev => ({
      ...prev,
      items: updatedItems,
      totalAmount: totalAmount
    }));
    setItems((prevData) => [
      ...prevData,
      {
        title: '',
        quantity: 1,
        price: 0,
        gst: 0,
      }
    ]);

  };


  const handleChange = (index, field, value) => {
    const updatedItems = [...items];
    updatedItems[index][field] = field === 'title' ? value : Number(value);
    setItems(updatedItems);
  };

  const handleAddRow = () => {
    setOrder((prevData) => ({
      ...prevData,
      items: [
        ...prevData.items,
        {
          title: '',
          quantity: 1,
          price: 0,
          gst: 0,
          isNew: true  // ✅ flag to identify new row
        }
      ]
    }));

    setItems((prevData) => [
      ...prevData,
      {
        title: '',
        quantity: 1,
        price: 0,
        gst: 0,
      }
    ]);


  }

  const [steps, setSteps] = useState([]); // Initialize steps as an empty array
  const [initialSteps, SetInitialSteps] = useState([]); // Initialize initialSteps as an empty array
  const [editingStep, setEditingStep] = useState(null); // Track the step being edited
  const [editedTitle, setEditedTitle] = useState('');
  const [editedDescription, setEditedDescription] = useState('');
  const [filteredTitles, setFilteredTitles] = useState([]); // Filtered title suggestions
  const [isAddingStep, setIsAddingStep] = useState(false); // Flag for showing the Add New Step form
  const [newStepTitle, setNewStepTitle] = useState(''); // Title for the new step
  const [newStepDescription, setNewStepDescription] = useState(''); // Description for the new step

  const availableTitles = [
    'Design Concept',
    'Material Sourcing',
    'Crafting',
    'Stone Setting',
    'Polishing and Finishing',
    'Quality Control',
    'Packaging',
    'Final Review'
  ];

  const getUserOrders = async () => {

    try {
      // const id = localStorage.getItem('userId');
      const { data } = await axiosInstance.get(`/user-orders-view/${id}`);

      if (data?.success) {
        console.log('order', data)
        setOrder(data?.userOrder ?? []);

        const fetchedSteps = data?.userOrder?.steps ?? [];
        setSteps(fetchedSteps);  // Update steps with fetched data
        SetInitialSteps(fetchedSteps); // Set initial steps (to avoid deletion of original steps)
      }
      setIsLoading(false); // Set loading state to false after fetching data

    } catch (error) {
      console.log(error);
      setIsLoading(false); // Set loading state to false in case of an error
      toast.error("order Not found");
      // navigate('/all-order');
    }
  };

  const addStep = () => {
    const newStep = {
      id: steps.length + 1, // Generate a new id for the new step
      title: newStepTitle, // Title from the input field
      date: new Date().toLocaleDateString(),
      description: newStepDescription // Description from the input field
    };
    setSteps([...steps, newStep]); // Add new step to the state
    setIsAddingStep(false); // Hide the input form after adding the step
    setNewStepTitle(''); // Reset the title field
    setNewStepDescription(''); // Reset the description field
  };

  const handleTitleChange = (e) => {
    const value = e.target.value;
    setNewStepTitle(value);

    // Filter availableTitles based on the input value
    const filtered = availableTitles.filter(title =>
      title.toLowerCase().includes(value.toLowerCase())
    );

    setFilteredTitles(filtered); // Set filtered titles for suggestions
  };

  const selectSuggestion = (suggestion) => {
    setNewStepTitle(suggestion); // Set the input to the selected suggestion
    setFilteredTitles([]); // Clear the suggestions
  };

  const deleteStep = (id) => {
    // Only allow deletion if the step is NOT part of the initial steps
    const isInitialStep = initialSteps.some((step) => step.id === id);
    if (!isInitialStep) {
      setSteps(steps.filter((step) => step.id !== id)); // Remove step from state
    }
  };

  const startEdit = (step) => {
    setEditingStep(step.id);
    setEditedTitle(step.title);
    setEditedDescription(step.description);
  };

  const saveEdit = (id) => {
    setSteps(steps.map((step) =>
      step.id === id ? { ...step, title: editedTitle, description: editedDescription } : step
    ));
    setEditingStep(null); // Clear editing state after saving
  };

  const cancelEdit = () => {
    setEditingStep(null); // Clear editing state without saving
  };



  const [showModal, setShowModal] = useState(false);

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);


  function formatDate(dateString) {
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-US', options);
  }




  const [searchQuery, setSearchQuery] = useState("");
  const [showSearch, setShowSearch] = useState("false");


  const handleInputChange = (e) => {
    setSearchQuery(e.target.value);
  };


  const handleClearClick = () => {
    setSearchQuery("");
  };


  const [AllProducts, setAllProducts] = useState([]);
  const [ProductId, setProductId] = useState({});

  const filteredProducts = AllProducts.filter((item) =>
    item.title.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const getUserAllPro = async () => {
    try {
      const response = await axiosInstance.get(`/all-products`);

      setAllProducts(response.data.products);
      console.log('setAllProducts', response.data.products)

    } catch (error) {
      console.error('Error fetching user products:', error);
    }
  };

  const handleClickProduct = (product) => {

    setOrder((prevData) => ({
      ...prevData,
      items: [
        ...prevData.items,
        {
          id: product._id,
          title: product.title,
          quantity: 1,
          price: product.salePrice,
          gst: product.gst || 0,
          isNew: true  // ✅ flag to identify new row
        }
      ]
    }));

    // setProductId(
    //   {
    //     name: product.title,
    //     id:  product._id,
    //   }
    // );
    setSearchQuery("");
  }



  useEffect(() => {

    getUserOrders();
    getUserAllPro();
  }, []);




  const requestTest = async (e) => {
    const newItems = Order?.items
      ?.filter(item => item.isNew)
      .map(({ isNew, ...rest }) => rest);  // ✅ remove isNew

    const sendmsg = {
      userId: Order?.userId,
      type: "Request",
      items: newItems,
      orderId: Order._id,
      id: Order.orderId,
    };

    sendMessage(sendmsg);
    console.log('sendmsg', sendmsg);

    //   await toast.promise(
    //       axiosInstance.post(`/admin/add-order-item`, sendmsg),
    //       {
    //         loading: "Sending Request...", // Loading message
    //         success: "Sending Request successfully!", // Success message
    //         error: "Failed to Send Request", // Error message
    //       }
    //     );

    //     } catch (error) {
    //   console.error('Error fetching user products:', error);
    //       } 

  };

  function convertTo24Hour(timeStr) {
    if (!timeStr) return "";
    const [time, modifier] = timeStr.split(" ");
    let [hours, minutes] = time.split(":").map(Number);

    if (modifier === "PM" && hours < 12) hours += 12;
    if (modifier === "AM" && hours === 12) hours = 0;

    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
  }


  function convertTo12Hour(timeStr) {
    if (!timeStr) return "";
    let [hours, minutes] = timeStr.split(":").map(Number);
    const modifier = hours >= 12 ? "PM" : "AM";

    hours = hours % 12 || 12; // convert 0 -> 12, 13 -> 1

    return `${hours}:${String(minutes).padStart(2, "0")} ${modifier}`;
  }

  const startJob = async (time) => {


    const mydata = {
      time,
      OrderId: id,
      otp: Order.otp,
    }
    try {
      if (time === 'start') {
        await toast.promise(
          axiosInstance.post(`/admin/order/timer`, mydata),
          {
            loading: "Job starting...", // Loading message
            success: "Job started successfully!", // Success message
            error: "Failed to start job", // Error message
          }
        );

      } else {
        await toast.promise(
          axiosInstance.post(`/admin/order/timer`, mydata),
          {
            loading: "Job ending...", // Loading message
            success: "Job ending successfully!", // Success message
            error: "Failed to ending job", // Error message
          }
        );

      }

      setTimeout(function () {
        window.location.reload();
      }, 1000); // 1000 milliseconds = 1 second


    } catch (error) {
      toast.error(error.response.data.message);
      console.error('Error start job:', error);
    } finally {
      getUserOrders();

    }
  }

  const [SubmitLoading, setSubmitLoading] = useState(true); // Add loading state


  const UserUpdateData = async () => {
    setSubmitLoading(false);

    try {

      const finaldata = {
        ...Order,
        steps
      }

      console.log("Sending updated Order data:", finaldata);

      const response = await axiosInstance.put(`/admin/update-full-order/${id}`, finaldata);

      if (response.data.success) {
        toast.success("Data updated successfully!");
      } else {
        toast.error("Update failed.");
      }
    } catch (error) {
      console.error("Error updating order:", error);
      toast.error("Error updating order");
    } finally {
      setSubmitLoading(true);
      getUserOrders(); // Refresh updated data
    }
  };



  return (
    <>
      <Sidebar />
      <main class="content">
        <Navbar />

        <div className="pt-4 px-5">
          <nav aria-label="breadcrumb" className="d-none d-md-inline-block">
            <ol className="breadcrumb breadcrumb-dark breadcrumb-transparent">
              <li className="breadcrumb-item">
                <a href="#">
                  <svg
                    className="icon icon-xxs"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                    />
                  </svg>
                </a>
              </li>
              <li className="breadcrumb-item">
                <a href="#">Admin</a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                OrderID #{Order.orderId}
              </li>
            </ol>
          </nav>
          <div className="d-flex justify-content-between w-100 flex-wrap">

            <div>
              {" "}
              <Link
                to={`${(mydatatype === 1 && mydatatypeEmp === 2) ? '/all-order' : '/all-order'}`}
                id="goBackButton"
                className="btn btn-primary d-inline-flex align-items-center"
              >
                <svg
                  style={{ transform: "rotate(180deg)" }}
                  className="icon icon-sm"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
                Go back
              </Link>
            </div>


            {/* <Link to={fronturl + 'account/order/' + Order?.userId + '/' + Order._id} className="btn btn-primary py-1">
              <i className="bi bi-download" />{" "}
              <span className="text">Invoice</span>
            </Link> */}

          </div>
        </div>

        <div id="main-content" className="bg-transparent ">

          {isLoading ? (
            // Display loading skeletons while data is being fetched
            Array.from({ length: 2 }).map((_, index) => (
              <div className="col-md-12" key={index}>

                <div className="skeleton mb-3" style={{ height: 154, borderRadius: 2 }} />

              </div>
            ))
          ) :
            (<>


              <div className='container mt-4 row mx-auto px-0'>


                {(mydata.type === 0 || (mydata.type === 1 && mydata.empType === 1)) &&

                  <>
                    <hr />
                    <h4> Customer Details </h4>
                    <div>

                      {/* Header */}
                      <div className="col-md-4">
                        {(Order.userId[0].profile && Order.userId[0].profile !== '') &&
                          <div
                            className="bg-primary text-white rounded-circle d-flex justify-content-center align-items-center me-3 shadow-sm overflow-hidden"

                          >
                            <img alt='profile' src={weburl + Order.userId[0].profile} className='w-100' style={{ aspectRatio: '1/1', objectFit: 'contain' }} />
                          </div>
                        }


                      </div>


                    </div>
                    {/* Name input */}
                    <div className="form-outline col-md-12 mb-4">
                      <label className="form-label" htmlFor="form5Example1">
                        Full Name <span className="text-danger"> (Required )</span>
                      </label>
                      <input
                        type="text"
                        name="fullname"
                        id="form5Example1"
                        className="form-control"
                        value={Order?.details[0]?.username}

                        style={{ boxShadow: "none" }}

                        onChange={(e) =>
                          setOrder((prev) => ({
                            ...prev,
                            details: [
                              {
                                ...prev.details[0],
                                username: e.target.value
                              }
                            ]
                          }))
                        }

                      />
                    </div>
                    {/* Email input */}
                    <div className="form-outline col-md-6 mb-4">
                      <label className="form-label" htmlFor="form5Example2">
                        Phone No. <span className="text-danger"> (Required )</span>
                      </label>
                      <input
                        type="number"
                        id="form5Example2"
                        className="form-control"
                        name="phone"
                        value={Order?.details[0]?.phone}

                        onChange={(e) =>
                          setOrder((prev) => ({
                            ...prev,
                            details: [
                              {
                                ...prev.details[0],
                                phone: e.target.value
                              }
                            ]
                          }))
                        }

                        style={{ boxShadow: "none" }}
                      />
                    </div>

                    <div className="form-outline col-md-6 mb-4">
                      <label className="form-label" htmlFor="form5Example2">
                        Email address{" "}
                        <span className="text-danger"> (Required )</span>
                      </label>
                      <input
                        type="email"
                        id="form5Example2"
                        className="form-control"
                        name="email"
                        value={Order?.details[0]?.email}

                        onChange={(e) =>
                          setOrder((prev) => ({
                            ...prev,
                            details: [
                              {
                                ...prev.details[0],
                                email: e.target.value
                              }
                            ]
                          }))
                        }

                        style={{ boxShadow: "none" }}
                      />
                    </div>


                    <div className="form-outline col-md-12 mb-4">
                      <label className="form-label" htmlFor="form5address">
                        Full Address
                        <span className="text-danger"> (Required )</span>
                      </label>

                      <textarea
                        type="text"
                        id="address"
                        className="form-control"
                        name="address"
                        value={Order?.details[0]?.address}
                        onChange={(e) =>
                          setOrder((prev) => ({
                            ...prev,
                            details: [
                              {
                                ...prev.details[0],
                                address: e.target.value
                              }
                            ]
                          }))
                        }
                        style={{ boxShadow: "none" }}
                      />

                    </div>

                    <div className="form-outline col-md-12 mb-4 d-none">
                      <label className="form-label" htmlFor="form5Example2">
                        Pincode
                        <span className="text-danger"> (Required )</span>
                      </label>
                      <input
                        type="text"
                        id="pincode"
                        className="form-control"
                        name="pincode"
                        value={Order?.details[0]?.pincode}
                        onChange={(e) =>
                          setOrder((prev) => ({
                            ...prev,
                            details: [
                              {
                                ...prev.details[0],
                                pincode: e.target.value
                              }
                            ]
                          }))
                        }
                        style={{ boxShadow: "none" }}
                      />
                    </div>

                  </>
                }

                <div className='col-12 '>
                  <h4>Order Details</h4>
                </div>


                <hr className="my-3" />
                {/* Invoice Dates */}
                <div className="d-flex text-center mb-3">
                  <div className="col-6 bg-white rounded-3 py-2 me-1 border">
                    <small className="text-muted d-block">Order Date</small>
                    <span className="fw-semibold">  {formatDate(Order.createdAt)}  </span>
                  </div>
                  <div className="col bg-white rounded-3 py-2 ms-1 border">
                    <small className="text-muted d-block">Payment Status</small>
                    <span className={`text-white px-2 rounded ${Order.payment === 0 ? 'bg-danger' : Order.payment === 1 ? 'bg-success' : 'bg-warning'}`}>
                      {
                        Order.payment === 0 ? 'unpaid' :
                          Order.payment === 1 ? 'Full Paid' :
                            Order.payment === 3 ? 'Partially  Paid' :

                              'failed'
                      }
                    </span>
                    <br />  ₹{Order.paid}
                  </div>
                </div>

                {/* Item List */}
                <div className="list-group rounded-4 mb-3">
                  {Order.items.map((Pro) => (
                    <div
                      key={Pro.id}
                      className="list-group-item border-0 rounded-0 border-bottom d-flex justify-content-between align-items-center"
                    >
                      <div className="d-flex align-items-center">
                        <img
                          src={Pro.id === '1' ? weburl + Pro.image : Pro.image}
                          alt={Pro.title}
                          width={40}
                          className="rounded me-3"
                          style={{ aspectRatio: '1/1', objectFit: 'cover' }}
                          data-bs-toggle="modal" data-bs-target="#exampleModal"
                        />
                        <div>
                          <strong>{Pro.title}</strong>
                          <div>
                            <small className="text-muted">
                              {Pro.quantity} × ₹{Math.round(Pro.price).toFixed(0)}
                            </small>
                          </div>
                        </div>
                      </div>
                      <span className="fw-semibold">
                        ₹{Math.round(Pro.price * Pro.quantity).toFixed(0)}
                      </span>
                    </div>
                  ))}
                </div>

                {/* Summary */}
                <div className="p-3 bg-white rounded-3 border mb-3">
                  <h6 className="text-primary fw-semibold mb-3">Total Summary</h6>

                  {/* Subtotal */}
                  <div className="d-flex justify-content-between mb-2">
                    <span className="text-muted">Subtotal</span>
                    <span className="fw-semibold">
                      ₹{Math.round(
                        Order.items.reduce(
                          (total, item) => total + item.quantity * (item.price ?? 0),
                          0
                        )
                      )}
                    </span>
                  </div>

                  {/* Shipping */}
                  <div className="d-flex justify-content-between mb-2">
                    <span className="text-muted">Shipping</span>
                    <span className="fw-semibold">₹{Order.shipping}</span>
                  </div>



                  {/* Coupon Discount */}
                  <div className="d-flex justify-content-between mb-2">
                    <span className="text-muted">Coupon Discount</span>
                    <span className="fw-semibold text-danger">
                      {Order.discount && Math.abs(Order.discount) > 0
                        ? `- ₹${Math.abs(Order.discount)}`
                        : '₹0'}
                    </span>
                  </div>

                  <hr className="my-2" />

                  {/* Grand Total */}
                  <div className="d-flex justify-content-between align-items-center">
                    <h6 className="fw-bold mb-0">Total</h6>
                    <h5 className="fw-bold text-primary mb-0">₹{Order.totalAmount}</h5>
                  </div>
                </div>

                <br />




                {Order.items[0].custom &&
                  <div
                    className="modal fade"
                    id="exampleModal"
                    tabIndex={-1}
                    aria-labelledby="exampleModalLabel"
                    aria-hidden="true"
                    style={{ backgroundColor: '#00000029' }}
                  >
                    <div className="modal-dialog">
                      <div className="modal-content">
                        <div className="modal-header">
                          <h1 className="modal-title fs-5" id="exampleModalLabel">
                            Image
                          </h1>
                          <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                          />
                        </div>
                        <div className="modal-body">
                          <img src={weburl + Order.items[0].image} className="w-100" style={{ aspectRatio: '1/1', objectFit: 'contain' }} />
                        </div>
                        <div className="modal-footer">
                          <button
                            type="button"
                            className="btn btn-dark"
                            data-bs-dismiss="modal"
                          >
                            Close
                          </button>

                        </div>
                      </div>
                    </div>
                  </div>

                }

                {Order.items[0].custom &&

                  <div className="card-body p-3 bg-white rounded mt-3 mb-3 bg-white border">
                    {/* Header */}
                    <div className="text-start mb-3 pb-2 border-bottom ">
                      <h6 className="text-primary text-uppercase mb-1 ">Additional Details</h6>
                      {/* <small className="text-muted">Webapp Design &amp; Development</small> */}
                    </div>

                    <div className="d-flex justify-content-between mb-2">
                      <span className="text-muted">Date</span>
                      <span className="fw-semibold"> {Order.items[0].custom.date
                        ? new Date(Order.items[0].custom.date).toLocaleDateString('en-GB', {
                          day: '2-digit',
                          month: 'long',
                          year: 'numeric'
                        })
                        : 'NA'} </span>
                    </div>
                    <div className="d-flex justify-content-between mb-2">
                      <span className="text-muted">Metal</span>
                      <span className="fw-semibold"> {Order.items[0].custom.metal ?? 'NA'} </span>
                    </div>
                    <div className="d-flex justify-content-between mb-2">
                      <span className="text-muted">Weight</span>
                      <span className="fw-semibold "> {Order.items[0].custom.weight + 'gm' ?? 'NA'} </span>
                    </div>
                    <hr className="my-2" />

                    <span className="text-dark fw-bold">Comment</span>
                    <div>
                      {Order.items[0].custom.comment + 'gm' ?? 'NA'}
                    </div>

                  </div>

                }

                {Order && Order.items[0].custom &&
                  <div className="card-body p-3 bg-white rounded mt-3 bg-white border mb-3">
                    <div className="text-start mb-3 pb-2 border-bottom">
                      <h6 className="text-primary text-uppercase mb-1">Project Progress</h6>
                    </div>

                    {isLoading ? (
                      <div>Loading...</div>
                    ) : (
                      <div className="d-flex flex-column">
                        {steps.length === 0 ? (
                          <div>No steps available.</div>
                        ) : (
                          steps.map((step) => (
                            <div key={step.id} className="d-flex align-items-start position-relative">
                              <div className="d-flex flex-column align-items-center me-3">
                                <div
                                  className="bg-success text-white rounded-circle d-flex justify-content-center align-items-center"
                                  style={{ width: 35, height: 35 }}
                                >
                                  <i className="ri-check-line" />
                                </div>
                                <div
                                  className="flex-grow-1 border-start border-2 border-success"
                                  style={{ minHeight: 40 }}
                                />
                              </div>
                              <div>
                                {/* Editable Title and Description */}
                                {editingStep === step.id ? (
                                  <>
                                    <input
                                      type="text"
                                      className="form-control mb-2"
                                      value={editedTitle}
                                      onChange={(e) => setEditedTitle(e.target.value)}
                                    />
                                    <textarea
                                      className="form-control mb-2"
                                      value={editedDescription}
                                      onChange={(e) => setEditedDescription(e.target.value)}
                                    />
                                    <div>
                                      <button
                                        className="btn btn-success btn-sm me-2"
                                        onClick={() => saveEdit(step.id)}
                                      >
                                        Save
                                      </button>
                                      <button
                                        className="btn btn-secondary btn-sm"
                                        onClick={cancelEdit}
                                      >
                                        Cancel
                                      </button>
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    <h6 className="fw-semibold mb-0">{step.title}</h6>
                                    <small className="text-primary fw-bold">- {step.date}</small>
                                    <p className="text-muted small mt-1 mb-0">{step.description}</p>
                                    {/* Show the delete and edit buttons only for new steps */}
                                    {!initialSteps.some((initialStep) => initialStep.id === step.id) && (
                                      <div>
                                        <button
                                          className="btn btn-warning btn-sm me-2"
                                          onClick={() => startEdit(step)}
                                        >
                                          Edit
                                        </button>
                                        <button
                                          className="btn btn-danger btn-sm"
                                          onClick={() => deleteStep(step.id)}
                                        >
                                          Delete
                                        </button>
                                      </div>
                                    )}
                                  </>
                                )}
                              </div>
                            </div>
                          ))
                        )}
                      </div>
                    )}

                    <div className="mt-3">
                      {/* Button to toggle Add New Step input */}
                      {!isAddingStep ? (
                        <button className="btn btn-primary" onClick={() => setIsAddingStep(true)}>
                          Add New Step
                        </button>
                      ) : (
                        <div>

                          <div className='w-100 mb-3'>
                            <label className='w-100'>Suggestions</label>

                            {availableTitles.map((suggestion, index) => (
                              <span
                                key={index}
                                className="badge rounded-pill bg-primary p-2 me-2 mt-2 "
                                onClick={() => selectSuggestion(suggestion)}

                              >
                                {suggestion}
                              </span>
                            ))}
                          </div>

                          {/* Input and suggestion list for adding a new step */}
                          <input
                            type="text"
                            className="form-control mb-2"
                            value={newStepTitle}
                            onChange={handleTitleChange} // Handle title input changes
                            placeholder="Enter new step title"
                          />


                          <textarea
                            className="form-control mb-2"
                            value={newStepDescription}
                            onChange={(e) => setNewStepDescription(e.target.value)}
                            placeholder="Enter step description"
                          />

                          <button className="btn btn-success btn-sm me-2" onClick={addStep}>
                            Add Step
                          </button>
                          <button
                            className="btn btn-secondary btn-sm"
                            onClick={() => setIsAddingStep(false)} // Cancel adding new step
                          >
                            Cancel
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                }

                <div className='overflow-auto d-none'>
                  <table style={{ borderCollapse: "collapse", width: "100%" }}>
                    <tbody>
                      <tr style={{ background: '#00406e', color: "white" }} >
                        <td style={{ padding: 10, fontWeight: "bold" }}>Items</td>
                        <td style={{ padding: 10, fontWeight: "bold" }}> Price </td>


                        {/* {Order.primary === 'true' ? (<>
                                    <td style={{ padding: 10, fontWeight: "bold" }}>CGST</td>
                                  <td style={{ padding: 10, fontWeight: "bold" }}>SGST</td>
                                  </>):(<>
                                    <td style={{ padding: 10, fontWeight: "bold" }}>IGST	</td>
                                    </>) }
                                   */}

                        <td style={{ padding: 10, fontWeight: "bold" }}>Total </td>


                      </tr>


                      {Order.items.map((Pro) => (
                        <tr >
                          <td style={{ padding: 10, maxWidth: '300px', minWidth: 300, borderWidth: '1px', borderColor: '#a2a2a2' }} className='text-nowrap'>
                            <div className="d-flex mb-2 text-nowrap">
                              <div className="flex-shrink-0 text-nowrap">
                                <img
                                  src={Pro.image}
                                  alt=""
                                  width={35}
                                  className="img-fluid"
                                />
                              </div>
                              <div className="flex-lg-grow-1 ms-3 text-nowrap">
                                <h6 className="small mb-0 text-nowrap">
                                  <Link href={`/product/${Pro.id}`} className="text-reset text-nowrap">
                                    {Pro.title}
                                  </Link>
                                  <p className='text-dark small'>

                                    <div className="fs-sm">
                                      <span className="text-body-secondary">Date: </span>
                                      <span className="text-body-secondary">  {Pro?.date ? new Date(Pro.date).toLocaleDateString('en-US', {
                                        weekday: 'short',
                                        day: '2-digit',
                                        month: 'short'
                                      }) : 'NA'} </span>
                                    </div>

                                    <div className="fs-sm">
                                      <span className="text-body-secondary">Time: </span>
                                      <span className="text-body-secondary">{Pro?.time || 'NA'} / {Pro.hour + ' Hour' || 'NA'}</span>
                                    </div>
                                  </p>
                                </h6>

                              </div>
                            </div>
                          </td>


                          <td style={{ padding: 10, borderWidth: '1px', borderColor: '#a2a2a2' }}  >₹{Math.round(Pro.price).toFixed(0)} </td>


                          {/* {Order.primary === 'true' ? (<>
                                      <td style={{ padding: 10, borderWidth: '1px', borderColor: '#a2a2a2' }} > ₹{(Pro.GSTPrice - Pro.price)/2}	 </td>
                                      <td style={{ padding: 10, borderWidth: '1px', borderColor: '#a2a2a2' }} >  ₹{(Pro.GSTPrice - Pro.price)/2} </td>
                                 
                                  </>):(<>
                                    <td style={{ padding: 10, borderWidth: '1px', borderColor: '#a2a2a2' }}> ₹{(Pro.GSTPrice - Pro.price)}	</td>
                                    </>) } */}


                          <td style={{ padding: 10, borderWidth: '1px', borderColor: '#a2a2a2' }} > ₹{Pro.quantity * Pro.GSTPrice} </td>

                        </tr>
                      ))}


                    </tbody>
                    <tfoot >
                      {/* <tr>
                                  <td  style={{
                                    padding: ".75rem",
                                    verticalAlign: "top",
                                    borderWidth: '1px', borderColor: '#a2a2a2'
                                  }} >
Total
                                  </td>
                              
                          

                          
        
                                  <td  style={{
                                    padding: ".75rem",
                                    verticalAlign: "top",
                                    borderWidth: '1px', borderColor: '#a2a2a2'
                                  }} >
                                  ₹{Order.items.reduce((total, item) => total + item.regularPrice - item.price , 0)}
                                  </td>

                                  
                                  {Order.primary === 'true' ? (<>
                                      <td style={{ padding: 10, borderWidth: '1px', borderColor: '#a2a2a2' }} >  ₹{Math.round(Order.items.reduce((total, item) => total + (((item.GSTPrice * item.gst) / 100)/2), 0)).toFixed(0)}  </td>
                                      <td style={{ padding: 10, borderWidth: '1px', borderColor: '#a2a2a2' }} >  
                                      ₹{Math.round(Order.items.reduce((total, item) => total + (((item.price * item.gst) / 100)/2), 0)).toFixed(0)}
                                       </td>

                                  </>):(<>
                                    <td style={{ padding: 10, borderWidth: '1px', borderColor: '#a2a2a2' }} >  ₹{Math.round(Order.items.reduce((total, item) => total + (((item.GSTPrice * item.gst) / 100)), 0)).toFixed(0)}  </td>
                                    </>) }

                                  
                                  <td  style={{
                                    padding: ".75rem",
                                    verticalAlign: "top",
                                    borderWidth: '1px', borderColor: '#a2a2a2'
                                  }} >
                                  ₹{Order.items.reduce((total, item) => total + item.quantity * item.GSTPrice , 0)}
                                  </td>


                                </tr> */}
                      <tr>
                        <td colSpan={10} >
                          <br />
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={Order.primary === 'true' ? 1 : 0}></td>
                        <td colSpan={1} style={{
                          padding: ".75rem",
                          verticalAlign: "top",
                          borderWidth: '1px', borderColor: '#a2a2a2'
                        }} > Subtotal </td>
                        <td className="text-end" style={{
                          padding: ".75rem",
                          verticalAlign: "top",
                          borderWidth: '1px', borderColor: '#a2a2a2'
                        }} >₹{Order.items.reduce((total, item) => total + item.quantity * item.GSTPrice, 0)}</td>
                      </tr>




                      <tr>
                        <td colSpan={Order.primary === 'true' ? 1 : 0}></td>


                        <td colSpan={1} style={{
                          padding: ".75rem",
                          verticalAlign: "top",
                          borderWidth: '1px', borderColor: '#a2a2a2'
                        }}  >  Shipping</td>
                        <td className="text-end" style={{
                          padding: ".75rem",
                          verticalAlign: "top",
                          borderWidth: '1px', borderColor: '#a2a2a2'
                        }}  >₹{Order.shipping}</td>
                      </tr>

                      {(Order.items[0]?.NightCharges ?? 0) !== 0 &&

                        <tr>
                          <td colSpan={Order.primary === 'true' ? 1 : 0}></td>

                          <td colSpan={1} style={{
                            padding: ".75rem",
                            verticalAlign: "top",
                            borderWidth: '1px', borderColor: '#a2a2a2'
                          }}  > Night Charges </td>

                          <td className="text-dark text-end" style={{
                            padding: ".75rem",
                            verticalAlign: "top",
                            borderWidth: '1px', borderColor: '#a2a2a2'
                          }} >
                            ₹  {Order.items[0]?.NightCharges ?? 0}
                          </td>
                        </tr>

                      }



                      <tr>
                        <td colSpan={Order.primary === 'true' ? 1 : 0}></td>

                        <td colSpan={1} style={{
                          padding: ".75rem",
                          verticalAlign: "top",
                          borderWidth: '1px', borderColor: '#a2a2a2'
                        }}  > Coupon Discount </td>

                        <td className="text-danger text-end" style={{
                          padding: ".75rem",
                          verticalAlign: "top",
                          borderWidth: '1px', borderColor: '#a2a2a2'
                        }} > {Order.items.reduce((total, item) => total + item.quantity * item.price, 0) - Math.abs(Order.discount) === 0 ? '₹0' : (
                          <>- ₹{Math.abs(Order.discount)}
                          </>
                        )}  </td>
                      </tr>
                      <tr className="fw-bold">
                        <td colSpan={Order.primary === 'true' ? 1 : 0}></td>

                        <td colSpan={1} style={{
                          padding: ".75rem",
                          verticalAlign: "top",
                          borderWidth: '1px', borderColor: '#a2a2a2'
                        }}  > TOTAL</td>
                        <td className="text-end" style={{
                          padding: ".75rem",
                          verticalAlign: "top",
                          borderWidth: '1px', borderColor: '#a2a2a2'
                        }}>₹{Order.totalAmount}</td>
                      </tr>
                    </tfoot>


                  </table>
                </div>



                {/* 
<div className='d-flex align-items-center justify-content-end gap-2 mt-2'>
<button className="btn btn-secondary btn-sm"> <i className="ri-restart-line"/> Refresh</button>
<button className="btn btn-success text-white btn-sm" onClick={requestTest}>  Send
   <i className="ri-send-plane-2-fill"/> </button>
</div> */}

                {/* <div  className="form-outline col-md-12 mb-4">
                  <label className="form-label" htmlFor="form5Example2">
                    Comment{" "}
                    <span className="text-danger"> (Required )</span>
                  </label>
                  <textarea
                    type="text"
                    id="comment"
                    className="form-control"
                    name="comment"
                    value={Order.comment}
                    
                    style={{ boxShadow: "none" }}
                  />
                 
                </div>  
				 */}




                <div className="col-12 mb-3">
                  {SubmitLoading ? (
                    <button
                      className="btn btn-secondary"
                      type="button"
                      onClick={UserUpdateData}
                    >
                      Update Data
                    </button>
                  ) : (
                    <button
                      class="btn btn-secondary btn-sm"
                      type="button"
                      disabled
                    >
                      <span class="ms-1">Loading...</span>
                      <span
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    </button>
                  )}
                </div>


              </div>





            </>)}





        </div>


      </main>
    </>
  )
}

export default FullOrderView